import { createFileRoute, redirect } from '@tanstack/react-router'

import { movedToConsole } from '@/features/auth/require-session'
import { marketSearchSchema } from '@/features/market/market-search'

/** The Market's old address: the console's Market for the operator, the evaluations for anyone else. */
export const Route = createFileRoute('/_app/market/')({
  validateSearch: (search) => marketSearchSchema.parse(search),
  beforeLoad: ({ context, search }) =>
    movedToConsole(context.queryClient, () =>
      redirect({ to: '/platform/market', search, replace: true }),
    ),
})
